import { Query } from 'graphql/generated/graphqlTypes';
import { mockVisitorsWithGroups } from 'mocks/graphqlMocks/visitorFixtures';

export function getAllVisitorsForTenantDataForQuery(getVisitors: Query['getVisitors']): Pick<Query, 'getVisitors'> {
  return { getVisitors };
}

export const mockedGetAllVisitorsForTenantData = getAllVisitorsForTenantDataForQuery(mockVisitorsWithGroups);
